import {
  doc,
  updateDoc,
  increment,
  setDoc
} from "firebase/firestore";

import { dbstatus } from "../firebase";
import Cookies from "js-cookie";

export const Update_status_message_qry = async (contentid, increase_column) => {

  // VALIDATION
  if (!contentid || !contentid.trim()) {
    return { success: false, error: "Missing contentid" };
  }

  if (!increase_column) {
    return { success: false, error: "Missing column name" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
  const usercity = Cookies.get("city") || "Unknown";
    const userpostcode = Cookies.get("postcode") || "000000";
    const userstate = Cookies.get("state") || "N/A";
    const usercountryname = Cookies.get("country") || "N/A";
    const userlatitude = Cookies.get("latitude") || "0";
    const userlongitude = Cookies.get("longitude") || "0";
    const useraddress = Cookies.get("address") || "Not Available";
    const tablename = "statusmessage";

    const docRef = doc(dbstatus, tablename, contentid);

    // increase counter
    await updateDoc(docRef, {
      [increase_column]: increment(1)
    });

    const uid = contentid + "_" + guid;

    const counterdocRef = doc(dbstatus, "reading_history", uid);

    await setDoc(counterdocRef, {
      column: increase_column,
      contentid,
      uid,
      guid,
      indexnumber: 0,
      sessiontoken,
      city: usercity,
      postcode: userpostcode,
      state: userstate,
      country: usercountryname,
      address: useraddress,
      latitude: userlatitude,
      longitude: userlongitude,
      status: true,
      date_time: Date.now()
    });

    return { success: true };

  } catch (err) {

    console.error("❌ Update_status_message_qry:", err);

    return {
      success: false,
      error: err.message || "Firestore operation failed"
    };

  }
};